<template>
	<div class="files-upload" :class="{ thumbs: listStyle == 'thumb' }">
		<div class="list">
			<template v-if="multiple">
				<div
					class="file-item bg-08dp"
					v-for="(file, index) in context.model"
					:key="file.id"
					:class="[displayBlock ? 'w-100 m-0' : '']"
				>
					<div
						class="thumb"
						@click="previewFile(index, file)"
						v-if="file.type == 'image'"
						:style="{ backgroundImage: `url('${file.urlThumb}')` }"
					></div>
					<div class="thumb thumb-document" @click="previewFile(index, file)" v-if="file.type == 'file'">
						<i class="icon icon-attach"></i>
					</div>
					<div class="filename" @click="previewFile(index, file)" v-if="context.model.type == 'file'">
						{{ file.filename }}
					</div>
					<div class="btn btn-delete" @click="remove(file)"><i class="icon icon-sm icon-close"></i></div>
				</div>
			</template>
			<div class="file-item bg-08dp" v-if="!multiple && context.model" :class="[displayBlock ? 'w-100 m-0' : '']">
				<div
					class="thumb"
					@click="previewFile(0, context.model)"
					v-if="context.model.type == 'image'"
					:style="{ backgroundImage: `url('${context.model.urlThumb}')` }"
				></div>
				<div
					class="thumb thumb-document"
					@click="previewFile(0, context.model)"
					v-if="context.model.type == 'file'"
				>
					<i class="icon icon-attach"></i>
				</div>
				<div class="filename" @click="previewFile(0, context.model)" v-if="context.model.type == 'file'">
					{{ context.model.filename }}
				</div>
				<div class="btn btn-delete" @click="remove(context.model)"><i class="icon icon-sm icon-close"></i></div>
			</div>

			<div
				class="file-item upload-box bg-08dp text-center"
				v-ripple
				:class="[
					invalid ? 'invalid' : '',
					dragging ? 'dragging' : '',
					uploadButtonClass,
					displayBlock ? 'w-100 m-0' : ''
				]"
				@dragenter="dragging = true"
				@dragend="dragging = false"
				@dragleave="dragging = false"
				@drop="dragging = false"
				v-if="multiple || (context.model.length == 0 && !multiple)"
			>
				<i class="icon-camera" v-if="!imagePlaceholder"></i>
				<div v-if="listStyle == 'thumb' && !imagePlaceholder">
					<strong>{{ placeholder }}</strong>
				</div>
				<div
					v-if="listStyle == 'thumb' && imagePlaceholder"
					class="imagePlaceholder"
					:style="{ backgroundImage: `url('${imagePlaceholder}')` }"
				></div>
				<div v-if="listStyle != 'thumb' && !imagePlaceholder">
					<strong>{{ placeholder }}</strong>
				</div>

				<input type="file" @change="processUploadImage" ref="file" />

				<div class="uploading" v-if="uploading">
					<div class="filename">
						{{ uploading.name }} asdasd
						<div class="loader"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="invalid-feedback d-block mt-1 mb-4" v-if="invalidFormat">Formato de archivo no permitido</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import axios from "axios"
import Tinybox from "vue-tinybox"

export default {
	name: "attachedFiles",
	components: {
		Tinybox
	},
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	computed: {
		files: {
			get: function () {
				return this.context.model || []
			},
			set: function (newValue) {
				this.context.model = newValue
			}
		},
		multiple: {
			get: function () {
				return this.context.attributes.multiple || false
			}
		},
		listStyle: {
			get: function () {
				return this.context.attributes.listStyle || false
			}
		},
		displayBlock: {
			get: function () {
				return this.context.attributes.displayBlock || false
			}
		},
		accept: {
			get: function () {
				return this.context.attributes.accept || "all" // all files, images
			}
		},
		uploadButtonClass: {
			get: function () {
				return this.context.attributes.uploadButtonClass || ""
			}
		},
		imagePlaceholder: {
			get: function () {
				return this.context.attributes.imagePlaceholder || ""
			}
		},
		placeholder: {
			get: function () {
				return this.context.attributes.placeholder || "Sacar foto"
			}
		}
	},

	data() {
		return {
			uploadedImage: {},
			uploading: false,
			invalid: false,
			invalidFormat: false,
			backgroundImage: null,
			API_URL: process.env.VUE_APP_API_URL,
			filetypes: [
				"doc",
				"docx",
				"xls",
				"xlsx",
				"ppt",
				"pdf",
				"zip",
				"rar",
				"7z",
				"odt",
				"ods",
				"ppt",
				"pptx",
				"txt"
			],
			imagetypes: ["gif", "png", "jpeg", "jpg"],

			preview: {
				file: "",
				show: false
			},
			dragging: false,

			showDrawingScreen: false,
			backgroundDraw: null
		}
	},
	methods: {
		setUpload() {
			this.$refs.file.click()
		},

		processUploadImage() {
			this.invalidFormat = false
			var input = event.target
			if (input.files && input.files[0]) {
				if (this.isAcceptedFile(input.files[0])) {
					this.uploading = true
					this.$emit("uploading", true)

					// muestro pantalla de dibujo.
					this.backgroundDraw = input.files[0]
					if (this.context.attributes.canDraw) {
						this.showDrawingScreen = true
					} else {
						this.uploadToServer(this.backgroundDraw)
					}
				} else {
					this.$toast.error("Formato de archivo no admitido")

					this.invalidFormat = true
				}
			}
		},

		async uploadToServer(image) {
			this.showDrawingScreen = false
			this.backgroundDraw = null
			this.uploading = true
			this.$emit("uploading", true)

			let formData = new FormData()
			formData.append("file", image)

			let token = localStorage.getItem("token-ckapp")

			const result = await axios.post(`${process.env.VUE_APP_API_URL}/upload`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
					authorization: "Bearer " + token
				}
			})
			console.log("upload result", result)
			if (result.data && result.data.status) {
				if (this.multiple) {
					if (!this.context || !Array.isArray(this.context.model)) this.context.model = []
					console.log(this.context)
					this.context.model.push(result.data.data)
				} else {
					this.context.model = result.data.data
				}
				this.$emit("input", this.context.model)
				this.$emit("uploaded", this.context.model)
				this.$emit("uploading", false)
				this.uploading = false
				return result.data.data
			}

			// this.showDrawingScreen = false
			// this.backgroundDraw = null
			// this.uploading = true
			// this.$emit('uploading', true)
			// return this.$apollo
			// 	.mutate({
			// 		mutation: gql`
			// 			mutation($file: Upload!) {
			// 				uploadFile(file: $file) {
			// 					id
			// 					url
			// 					urlThumb
			// 					filename
			// 					type
			// 				}
			// 			}
			// 		`,
			// 		variables: {
			// 			file: image,
			// 		},
			// 	})
			// 	.then(({ data }) => {
			// 		if (this.multiple) {
			// 			if (!Array.isArray(this.context.model)) this.context.model = []
			// 			this.context.model.push(data.uploadFile)
			// 		} else {
			// 			this.context.model = data.uploadFile
			// 		}
			// 		this.$emit('input', this.context.model)
			// 		this.$emit('uploading', false)
			// 		this.uploading = false
			// 		return data.uploadFile
			// 	})
			// 	.catch((err) => {
			// 		console.log(err)
			// 		this.uploading = false
			// 		return false
			// 	})
		},

		deletePrompt(item) {
			this.$dialog
				.confirm(
					{
						title: "Eliminar archivo",
						body: `¿Está seguro que desea eliminar el archivo <strong>"${item.filename} "</strong>?`
					},
					{
						okText: "Eliminar",
						customClass: "delete-prompt"
					}
				)
				.then(() => {
					this.remove(item)
				})
		},

		previewFile(index, file) {
			if (file.type == "image") {
				this.preview.images = this.context.model.map((file) => {
					return { src: file.url, thumbnail: file.urlThumb, index }
				})
				this.preview.index = index
				this.preview.show = true
				this.preview.file = file

				// this.$nextTick = () => {
				// 	this.loadSignatureBackground(this.preview.file.url)
				// }
			} else {
				console.log("Descargo el archivo")
			}
		},

		downloadFile(file) {
			console.log("download file")
			fetch(file.url)
				.then((response) => response.blob())
				.then((blob) => {
					saveAs(blob, file.filename)
				})
			// console.log('downloading', url);
		},

		isAcceptedFile(file) {
			let fileType = file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase()
			if (this.accept == "images") {
				return this.imagetypes.find((extension) => extension == fileType)
			} else if (this.accept == "files") {
				return this.filetypes.find((extension) => extension == fileType)
			} else {
				return (
					this.filetypes.find((extension) => extension == fileType) ||
					this.imagetypes.find((extension) => extension == fileType)
				)
			}
		},

		remove(file) {
			if (this.multiple) {
				const index = this.context.model.findIndex((f) => f.id == file.id)
				if (index >= 0) {
					this.context.model.splice(index, 1)
				}
			} else {
				this.context.model = null
			}
			this.preview.show = false
			this.$emit("input", this.context.model)
		}
	}
}
</script>

<style scoped lang="scss">
.btn-save {
	position: absolute;
	top: 0px;
	right: 0px;
}

.list {
	width: 100%;
	display: flex;
	flex-direction: column;
	color: #ffffff87;

	.file-item {
		// width: 100%;
		// border: 1px solid rgba(28,110,164,.2);
		margin: 4px 0;
		padding: 4px;
		border-radius: 4px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #93a4b912;

		flex-grow: 0;
		flex-shrink: 0;
		cursor: pointer;

		.filename {
			flex-grow: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.thumb {
			// background-color:#f3f3f3;
			border-radius: 3px;
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center center;
			width: 48px;
			height: 48px;
			margin-right: 8px;
			flex-shrink: 0;
		}

		.thumb-document {
			// background-color: #f7f7f7;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			i {
				font-size: 18px;
				color: #00000020;
			}
		}

		.btn-delete {
			color: #000;
		}
	}

	.upload-box {
		font-size: 12px;
		font-weight: 300;
		line-height: 15px;
		text-transform: capitalize;
		display: flex;
		align-items: center;
		justify-content: inherit;
		flex-grow: 0;
		flex-shrink: 0;
		cursor: pointer;

		i {
			font-size: 30px;
			line-height: 28px;
			text-align: center;
			margin: 0px 8px 0px 0px;
			display: block;
			color: #00000060;
		}

		input {
			opacity: 0;
			position: absolute;
			z-index: 10;
			top: 0px;
			width: 100%;
			height: 100%;
			cursor: pointer;
		}

		&.dragging,
		&:hover {
			border-color: #ffffff !important;
			color: #ffffff;
		}
		// &.w-100{
		//     width:100% !important;
		//     margin:0px !important;
		// }

		.uploading {
			position: absolute;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			// background-color: #fff;

			.filename {
				flex-grow: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
}

.files-upload.thumbs {
	.list {
		flex-direction: initial;
		flex-wrap: wrap;

		.file-item {
			width: 92px;
			height: 92px;
			margin: 4px;

			.thumb {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0px;
				left: 0px;
			}
			.btn-delete {
				position: absolute;
				top: 0px;
				right: 0px;
				display: none;
				i {
					color: #999;
				}
			}
			&:hover .btn-delete {
				display: block;
			}
			&:hover {
				border-color: #ffffff !important;
				color: #00000060;
			}
		}
		.upload-box {
			text-align: center;
			justify-content: center;
			flex-direction: column;

			i {
				font-size: 24px;
				margin: 0px;
			}

			.imagePlaceholder {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0px;
				left: 0px;
				z-index: 10;
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center;
			}
		}
	}
}

.lightbox {
	bottom: 0;
	left: 0;
	position: fixed;
	right: 0;
	text-align: center;
	top: 0;
	z-index: 1000;
}
.lightbox .content {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0px;
	z-index: 1010;
}
.lightbox .content .controls {
	width: 100%;
	height: 64px;
	top: 0px;
	position: absolute;
	padding: 0px 16px;
	z-index: 1010;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: rgba(0, 0, 0, 0.3);
}
.lightbox .content .controls .filename {
	color: #fff;
	padding: 8px 16px;
}
.lightbox .content .controls .btn {
	width: 46px !important;
	height: 46px !important;
	color: #fff;
	font-size: 20px;
}
.lightbox .backdrop {
	width: 100%;
	height: 100%;
	z-index: 1000;
	background-color: rgba(0, 0, 0, 0.8);
}

.lightbox .content .image {
	background-color: #222;
	// cursor: pointer;
	display: inline-block;
	max-height: 90%;
	max-width: 80%;
	// position: absolute;
	// background-size: contain;
}

.loader,
.loader:before,
.loader:after {
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	content: "";
	position: absolute;
	border-radius: 50%;
}

.loader {
	// position:fixed;
	width: 30px;
	height: 30px;
	margin: auto;
	animation: spin 4s linear infinite;
}

@keyframes spin {
	100% {
		transform: rotate(360deg);
		filter: hue-rotate(360deg);
	}
}

.loader:before {
	border: 2px solid #aaa;
	border-bottom: 2px solid orange;
	border-left: 2px solid orange;
	animation: spin1 1s linear infinite;
}

.loader:after {
	border: 2px solid #aaa;
	border-top: 2px solid transparent;
	border-right: 2px solid transparent;
	animation: spin2 1s linear infinite;
}

@keyframes spin1 {
	20% {
		transform: rotate(150deg);
	}
	40% {
		transform: rotate(300deg);
	}
	80% {
		transform: rotate(300deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@keyframes spin2 {
	0% {
		transform: rotate(-30deg);
	}
	20% {
		transform: rotate(-30deg);
		border-color: transparent transparent #aaa #aaa;
	}
	21% {
		border-color: orange orange transparent transparent;
	}
	40% {
		transform: rotate(-30deg);
	}
	60% {
		transform: rotate(120deg);
		border-color: orange orange transparent transparent;
	}
	61% {
		border-color: transparent transparent #aaa #aaa;
	}
	80% {
		transform: rotate(270deg);
	}
	100% {
		transform: rotate(330deg);
	}
}
</style>
